var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isAppInstalled)?_c('button',{on:{"click":_vm.addToHomeScreen}},[_vm._v(" Install on your device ")]):_c('div',[_vm._v("Installed")])])
}
var staticRenderFns = []

export { render, staticRenderFns }